import {GenericService} from '@/shared/xhttp';
import {Logement, Proprietaire, Upload} from '@/models';

export class UploadService extends GenericService<Upload> {

	public postDocumentProprietaire(proprietaire: Proprietaire, upload: Upload): Promise<Upload> {
		return this.post(`/proprietaire/${proprietaire.id}`, upload);
	}
}
